import PastWinner from 'components/PastWinner/PastWinner';
import withCountry from 'enhancers/withCountry';
import withFinalsPageQuery, { WithFinalsPageQueryProps } from 'enhancers/withFinalsPageQuery';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import * as Markdown from 'react-markdown';
import styled from 'styled-components';

type Props = WithFinalsPageQueryProps & WithLanguageProps;

export const FinalsPage: React.SFC<Props> = props => {
  if (!props.loading && props.data && props.data.fetch) {
    const background =
      props.data.fetch.Common.Finals && props.data.fetch.Common.Finals.Image
        ? props.data.fetch.Common.Finals.Image.src
        : '';
    return (
      <Container style={{ background: `url(${background})` }}>
        <Title>
          {props.getText(props.data.fetch.Country.FinalsPage.Title)}
        </Title>
        <Markdown
          className="finals-markdown"
          source={props.getText(props.data.fetch.Country.FinalsPage.Content)}
        />
        <WinnersText>
          {props.getText(props.data.fetch.Country.FinalsPage.PastWinnersTitle)}
        </WinnersText>
        <Winners>
          {(props.data.fetch.Common.Finals &&
          props.data.fetch.Common.Finals.Finalists
            ? props.data.fetch.Common.Finals.Finalists
            : []
          ).map((finalist, i) => (
            <PastWinnerContainer key={i}>
              <PastWinner {...finalist} />
            </PastWinnerContainer>
          ))}
        </Winners>
      </Container>
    );
  }
  return <div />;
};

const PastWinnerContainer = styled.div`
  margin: 0 15px;
  @media (max-width: 580px) {
    margin: 15px 0;
  }
`;

const Winners = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 580px) {
    flex-direction: column;
  }
`;

const WinnersText = styled.p`
  text-transform: uppercase;
  font-size: 29px;
  font-weight: 700;
`;

const Title = styled.h1`
  font-weight: 700;
  font-size: 85px;
  text-transform: uppercase;
  /* margin: 0 */
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  text-align: center;
  padding-bottom: 100px;
  background-repeat: no-repeat;
  .finals-markdown {
    p {
      line-height: 1.75;
    }
  }
`;

// const Content = styled.div``;

export default withLanguageState(withCountry(withFinalsPageQuery(FinalsPage)));



// WEBPACK FOOTER //
// ./src/pages/FinalsPage/FinalsPage.tsx